"use client";

import { useBoard } from "@/components/BoardProvider";

export function RequiredByUniversities() {
  const board = useBoard();

  return (
    <section className="w-full pt-8 md:pt-12 pb-14 md:pb-20">
      {/* Universities required by row (full-width) — driven by the active board */}
      <div className="flex flex-col items-center gap-4 w-full px-6">
        <p className="text-base md:text-lg text-muted-foreground font-polysans uppercase tracking-wide">
          {board.shortName} is required by
        </p>
        <div className="flex items-center gap-6 flex-wrap justify-center md:gap-10">
          {board.universities.map((uni) => {
            const key = uni.name.toLowerCase();
            const sizeMap: Record<string, string> = {
              imperial: "h-4 md:h-6", // smaller Imperial
              cambridge: "h-7 md:h-9", // slightly smaller Cambridge
              warwick: "h-14 md:h-20", // bigger Warwick
              lse: "h-16 md:h-20", // bigger LSE
              ucl: "h-12 md:h-18", // slightly smaller UCL
              durham: "h-9 md:h-18", // much smaller Durham
            };
            const sizeClass = sizeMap[key] ?? "h-8 md:h-10";
            // Most logos are transparent PNGs → flatten to a dark silhouette for
            // light mode. lse.png is an opaque red tile (no alpha):
            // grayscale + multiply keeps the tile grey and melts the white
            // canvas into the page instead of inverting red to cyan.
            const toneClass =
              key === "lse"
                ? "grayscale mix-blend-multiply opacity-60 hover:opacity-100"
                : "grayscale brightness-0 opacity-55 hover:opacity-100";
            return (
              <img
                key={key}
                src={uni.logo}
                alt={`${uni.fullName} logo`}
                className={`${sizeClass} object-contain ${toneClass} transition-opacity duration-200`}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}
